export default "/images/8ba5a869441181e35e60cfe60e5cd4fa.avif";